import Cookies from 'js-cookie'
import request from '@utils/request'

export const state = {
    cached: getCookie('merchant.cached') || '',
    cachedUsers: [],
    cachedUserGroups: [],
    cachedPlans: [],
}

export const getters = {}

export const mutations = {
    CACHE_MERCHANT(state, newValue) {
        state.cached = newValue
        setCookie('merchant.cached', newValue, 10)
    },
    CACHE_USER(state, users) {
        state.cachedUsers = users
    },
    CACHE_USER_GROUPS(state, groups) {
        state.cachedUserGroups = groups
    },
    CACHE_PLANS(state, plans) {
        state.cachedPlans = plans
    },
    // cashflowSetting
    // 0: 未申請
    // 1: 審核通過
    // 2: 審核中
    SET_PRICE_API_TO_CURRENT_USER_PERMISSION(state, newValue) {
        const permission = getCookie('auth.currentUserPermission')
        if (permission === null || Object.keys(permission).length === 0) return
        if (!permission.apis.includes('setPrice')) {
            if (newValue.cashflowSetting === 1) {
                permission.apis.push('setPrice')
                this.state.auth.currentUserPermission.apis.push('setPrice')
                setCookie('auth.currentUserPermission', permission)
            }
        }
    },
}

export const actions = {
    /**
     * 取得商店所有管理身份列表
     */
    fetchUserGroups({
        commit
    }) {
        const cachedUserGroups = state.cachedUserGroups
        if (cachedUserGroups.length > 0) return Promise.resolve(cachedUserGroups)

        return request.get('/admin/merchant/userGroups').then((response) => {
            const usersGroups = response.items
            commit('CACHE_USER_GROUPS', usersGroups)
            return usersGroups
        })
    },
    /**
     * 新增商店管理帳號
     */
    storeUser({
        commit
    }, submitData) {
        return request.post('/admin/merchant/user/store', submitData)
    },
    /**
     * 驗證欲新增的帳號 Email 是否已註冊
     */
    validUserEmail({
        commit
    }, email) {
        return request.post(
            '/admin/merchant/user/checkEmail', {
                email
            }, {
                errorHandle: false
            }
        )
    },
    /**
     * 取得商店所有管理帳號列表
     */
    fetchUsers({
        commit
    }, query) {
        return request
            .post('/admin/merchant/user/search', query)
            .then(({
                items,
                pagination: {
                    total
                }
            }) => {
                commit('CACHE_USER', items)
                return total
            })
    },
    /**
     * 取得單一付費發票
     */
    fetchSingleInvoice({
        commit
    }, historyId) {
        return request
            .get(`/admin/merchant/payment/invoice/search/${historyId}`)
            .then((response) => response.items)
    },
    /**
     * 訂閱付費紀錄列表
     */
    subscriptionHistory({
        commit
    }, mode) {
        return request
            .post('/admin/merchant/payment/history', {
                mode
            })
            .then((response) => response.items)
    },
    /**
     * 取得綁定信用卡並導向藍新
     */
    changeCard({
        commit
    }, merchantAlias) {
        return request
            .post('/merchant/bindCardPostData', {
                alias: merchantAlias
            })
            .then((response) => response.items)
    },
    /**
     * 金流申請
     */
    paymentApply({
        commit
    }, submitData) {
        return request
            .post('/admin/merchant/cashflow/add', submitData)
            .then((response) => {
                return response.items
            })
    },
    /**
     * 儲存商店資訊
     */
    store({
        commit
    }, storeData) {
        return request.post('/admin/merchant/store', storeData)
    },
    /**
     * 取得商店資訊
     */
    fetchSingle({
        commit
    }) {
        return request.get('/admin/merchant').then((response) => {
            const merchant = response.items
            commit('CACHE_MERCHANT', merchant)
            commit('SET_PRICE_API_TO_CURRENT_USER_PERMISSION', merchant)
            return merchant
        })
    },
    /**
     * 續訂原先方案
     */
    renewPlan() {
        return request.get('/admin/merchant/renew')
    },
    /**
     * 取得所有方案
     */
    fetchPlans({
        commit
    }) {
        return request.get('/plan/list').then((response) => {
            const plans = response
            commit('CACHE_PLANS', plans)
            return plans
        })
    },
    /**
     * 更新方案資訊
     */
    updateSubscription({
        commit
    }, userData) {
        commit('CACHE_MERCHANT', userData)
    },
    /**
     * 變更訂閱方案
     */
    storePlan({
        commit
    }, storeData) {
        return request.post('/admin/merchant/plan/store', storeData)
    },
    /**
     * 取得通知設定
     */
    fetchConfig({
        commit
    }, storeData) {
        return request.get('/admin/merchant/config').then((response) => response.items.notification)
    },
    /**
     * 發送通知
     */
    sendNoti({
        commit
    }, submitData) {
        return request.post('/admin/merchant/notification/send', submitData)
    },
    /**
     * 簡訊紀錄
     */
    fetchSmsHistory({
        commit
    }, query) {
        return request.post('/admin/merchant/smshistory/search', query).then((response) => {
            return {
                items: response.items,
                total: response.pagination.total,
            }
        })
    },
}

function getCookie(key) {
    return JSON.parse(Cookies.get(key) || null)
}

function setCookie(key, state, expiredInMiuntes) {
    return Cookies.set(key, JSON.stringify(state), {
        expires: expiredInMiuntes ? new Date(new Date().getTime() + expiredInMiuntes * 60 * 1000) : 7,
        sameSite: 'lax',
    })
}